import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';
import styles from './styles.scss';
import TextAreaContainer from '../../../molecules/textarea-container/TextAreaContainer';
import Utils from '../../../../utils/comments-utils';
import ErrorBoundary from '../../../atoms/error-boundary';

const ManageCommentReply = function ManageCommentReply(props) {
    const {
        reply, baseurl, author, targetKey, parentMessageKey,
    } = props;

    const { host, protocol } = new URL(baseurl);

    const [isReplyVisible, setIsReplyVisible] = useState(false);

    const [localReply, setLocalReply] = useState(reply);

    const [replyText, setReplyText] = useState('');

    function toggleShowTextBox(e) {
        e.preventDefault();
        setIsReplyVisible(!isReplyVisible);
    }

    function submitReply(e) {
        e.preventDefault();
        const replyRequestMessage = {
            Amount: 0,
            Author: author,
            MessageText: replyText,
            Parent: parentMessageKey,
            Targetkey: targetKey,
        };

        fetch(
            `${protocol}//${host}/odata/messages`,
            {
                method: 'POST',
                headers: new Headers({ 'content-type': 'application/json' }),
                body: JSON.stringify(replyRequestMessage),
            },
        )
            .then((response) => {
                if (response.status === 201) {
                    replyRequestMessage.Created = new Date().toLocaleString();
                    setLocalReply(replyRequestMessage);
                } else {
                    // ToDo: handle error for creating reply here
                }
            });
    }

    const pageUrl = '';

    return (
        <ErrorBoundary>
            <div className={styles.managecommentreply}>
                {localReply
                    ? (
                        <>
                            <div className="columns mb-0" data-testid="local-reply">
                                <div className="column has-text-black">
                                    <span>
                                        {localReply.Author}
                                    </span>
                                    <span className="ml-1">
                                        replied
                                    </span>
                                </div>
                                <div data-testid="created-content-div" className={`column is-narrow ${styles['blue-text']}`}>
                                    {Utils.CalculateTimeDiff(localReply.Created, true)}
                                </div>
                            </div>
                            <div className={styles['long-comment']}>
                                <ShowMoreText
                                    /* Default options */
                                    lines={3}
                                    more="Show more"
                                    less="Show less"
                                    className="content-css"
                                    expanded={false}
                                    width={345}
                                    truncatedEndingComponent="... "
                                >
                                    {localReply.MessageText}
                                </ShowMoreText>
                            </div>
                        </>
                    )
                    : (
                        <div className={styles['long-comment']}>
                            <div className={`${styles['reply-div']} has-text-weight-bold`}>
                                {isReplyVisible
                                    ? (
                                        <form method="post">
                                            <div data-testid="reply-text-div">
                                                <TextAreaContainer
                                                    maxcount={70}
                                                    placeholder="Reply.."
                                                    onInput={(e) => setReplyText(e.target.value)}
                                                >
                                                    <input type="text" name="MessageText" defaultValue="" />
                                                </TextAreaContainer>
                                                <div className={styles['buttons-div']}>
                                                    <input className={`${styles['cancel-button']} ${styles['reply-buttons']}`} type="button" label="Cancel" value="Cancel" onClick={toggleShowTextBox} />
                                                    <input className={`${styles['publish-button']} ${styles['reply-buttons']}`} type="submit" label="Publish" value="Publish" onClick={submitReply} />
                                                </div>
                                            </div>
                                        </form>
                                    )
                                    : (
                                        <div>
                                            <a href={pageUrl} className={styles['reply-text']} onClick={toggleShowTextBox}>
                                                Reply
                                            </a>
                                        </div>
                                    )}
                            </div>
                        </div>
                    )}
            </div>
        </ErrorBoundary>
    );
};

ManageCommentReply.propTypes = {
    reply: PropTypes.shape({
        MessageText: PropTypes.string.isRequired,
        Author: PropTypes.string.isRequired,
        TargetKey: PropTypes.string.isRequired,
        Created: PropTypes.string.isRequired,
    }),
    author: PropTypes.string.isRequired,
    targetKey: PropTypes.string.isRequired,
    parentMessageKey: PropTypes.string.isRequired,
    baseurl: PropTypes.string,
};

ManageCommentReply.defaultProps = {
    reply: null,
    baseurl: window.location.href,
};

export default ManageCommentReply;
